export default __webpack_public_path__ + "static/media/logo_pw.46c7afbc.png";